import { forwardRef, useImperativeHandle, useState } from 'react';
import { PopoverAtPoint } from '@ardoq/popovers';
import { UrlFieldValueList } from 'tabview/graphViews/UrlFieldValueList';
import type {
  SetUrlFieldValuesPopover,
  UrlFieldValuesPopoverState,
} from './getUrlFieldValuesPopoverState';

export type UrlFieldValuesPopoverHandle = {
  setUrlFieldValuesPopover: SetUrlFieldValuesPopover;
};

const UrlFieldValuesPopover = forwardRef<UrlFieldValuesPopoverHandle, object>(
  (_, ref) => {
    const [state, setState] = useState<UrlFieldValuesPopoverState | null>(null);
    useImperativeHandle(
      ref,
      () => ({ setUrlFieldValuesPopover: setState }),
      []
    );

    if (!state) {
      return null;
    }
    const close = () => setState(null);
    const { point, urlFieldValues, element } = state;
    return (
      <PopoverAtPoint
        point={point}
        isOpen
        onClose={close}
        placement={{ side: 'top', overflow: 'center' }}
        acceptsMouse
        onMouseLeave={close}
      >
        <UrlFieldValueList element={element} urlFieldValues={urlFieldValues} />
      </PopoverAtPoint>
    );
  }
);
UrlFieldValuesPopover.displayName = 'UrlFieldValuesPopover';
export { UrlFieldValuesPopover };
